$(function(){
    $('.burger').click(function() {
        $('.burger').toggleClass('burger_on');
        $('.offcanvas-menu').toggleClass('offcanvas-menu--show');
        $('body').toggleClass('overflow-hidden');
    });
});